var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.css(), _vm.css('', _vm.type)]},[_c('AtomGraphic',{key:_vm.graphicName,attrs:{"name":_vm.graphicName,"size":28}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }